import { render, staticRenderFns } from "./EmailDialogDelete.vue?vue&type=template&id=8438babe"
import script from "./EmailDialogDelete.ts?vue&type=script&lang=ts&external"
export * from "./EmailDialogDelete.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports